(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    var main = document.getElementById('MainContent');
    if (!main) return;

    // --- Fade / slide-in reveal for each homepage section ---
    if (!reduceMotion && 'IntersectionObserver' in window) {
      var sections = main.querySelectorAll(':scope > .shopify-section');
      sections.forEach(function (section, index) {
        if (index === 0) return; // skip the hero so it paints immediately
        section.classList.add('scroll-reveal');
      });

      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      main.querySelectorAll('.scroll-reveal').forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    // --- Parallax on the slideshow hero images ---
    if (!reduceMotion) {
      var parallaxImgs = main.querySelectorAll('.slideshow__media img');
      if (parallaxImgs.length) {
        var ticking = false;

        function updateParallax() {
          parallaxImgs.forEach(function (img) {
            var media = img.closest('.slideshow__media');
            if (!media) return;
            var rect = media.getBoundingClientRect();
            var offset = rect.top * -0.15;
            img.style.transform = 'scale(1.15) translateY(' + offset + 'px)';
          });
          ticking = false;
        }

        window.addEventListener(
          'scroll',
          function () {
            if (!ticking) {
              window.requestAnimationFrame(updateParallax);
              ticking = true;
            }
          },
          { passive: true }
        );

        updateParallax();
      }
    }
  });
})();
